
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qa/page",
      function () {
        return require("private-next-pages/qa/page/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qa/page"])
      });
    }
  